import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const UploadImage = forwardRef<SVGSVGElement, SvgIconProps>(
  function UploadImage(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="M6.646 5.357h3.57v2.404h-3.57v4.206h-2.38V7.761H.102V5.357h4.164V1.751h2.38v3.606zm3.77 6.61l3.964 3.005 1.985-1 3.964 2.402v1.603H8.43v-4.004l1.986-2.006zm9.913-.3c0 .83-.666 1.502-1.487 1.502a1.495 1.495 0 0 1-1.488-1.502c0-.83.666-1.503 1.488-1.503.821 0 1.487.673 1.487 1.503zm1.605-5.71v.001c1.078 0 1.958.876 1.964 1.949v11.72a1.965 1.965 0 0 1-1.964 1.955H6.23a1.965 1.965 0 0 1-1.965-1.954v-5.153h1.965v5.153h15.703V7.912h-9.17V5.958h9.17z" />
      </SvgIcon>
    )
  },
)

export default UploadImage
